import {ignite} from '../ignite.mjs';
import {getStore, storeInitialized} from '../stores/main-store.mjs';
import {enableLoginFlow} from '../actions/login-action-creators.mjs';

/* eslint-disable-next-line no-unused-vars */
const presentEmployeeLogin = async (allowClose, params = {}) => {
  try {
    await storeInitialized();
    const {
      selectedEmployeeId = ''
    } = params;
    const store = await getStore();
    store.dispatch(enableLoginFlow(selectedEmployeeId));
  } catch (ex) {
    console.error('Neuro store has not been initialized', ex);
  }
};

ignite.showEmployeeDialog = presentEmployeeLogin;
